import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Layout from "./components/Layout";
import WhatsAppFloat from "./components/WhatsAppFloat";

import Home from "./pages/Home";
import Services from "./pages/Services";
import TcfTraining from "./pages/TcfTraining";
import Events from "./pages/Events";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Booking from "./pages/Booking";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import PaymentResult from "./pages/PaymentResult";
import PublicDropBox from "./pages/PublicDropBox";
import TalentRegistry from "./pages/TalentRegistry";
import CouplesRegistry from "./pages/CouplesRegistry";
import TcfDiagnostic from "./pages/TcfDiagnostic";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";

import "./App.css";

function PageTransition({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.35, ease: [0.65, 0, 0.35, 1] }}
    >
      {children}
    </motion.div>
  );
}

function AnimatedRoutes() {
  const location = useLocation();

  // AUTH CALLBACK — detect session_id in URL fragment synchronously (before ProtectedRoute runs)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><Home /></PageTransition>} />
        <Route path="/services" element={<PageTransition><Services /></PageTransition>} />
        <Route path="/tcf" element={<PageTransition><TcfTraining /></PageTransition>} />
        <Route path="/drop-box" element={<PageTransition><PublicDropBox /></PageTransition>} />
        <Route path="/depot-documents" element={<PageTransition><PublicDropBox /></PageTransition>} />
        <Route path="/dropbox" element={<PageTransition><PublicDropBox /></PageTransition>} />
        <Route path="/tcf/diagnostic" element={<PageTransition><TcfDiagnostic /></PageTransition>} />
        <Route path="/events" element={<PageTransition><Events /></PageTransition>} />
        <Route path="/about" element={<PageTransition><About /></PageTransition>} />
        <Route path="/contact" element={<PageTransition><Contact /></PageTransition>} />
        <Route path="/booking" element={<PageTransition><Booking /></PageTransition>} />
        <Route path="/registry" element={<PageTransition><TalentRegistry /></PageTransition>} />
        <Route path="/registry/couples" element={<PageTransition><CouplesRegistry /></PageTransition>} />
        <Route path="/admin" element={<PageTransition><Admin /></PageTransition>} />
        <Route path="/login" element={<PageTransition><Login /></PageTransition>} />
        <Route path="/dashboard" element={<PageTransition><Dashboard /></PageTransition>} />
        <Route path="/payment/success" element={<PageTransition><PaymentResult success={true} /></PageTransition>} />
        <Route path="/payment/cancel" element={<PageTransition><PaymentResult success={false} /></PageTransition>} />
        <Route path="*" element={<PageTransition><NotFound /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <Navbar />
          <Layout>
            <AnimatedRoutes />
          </Layout>
          <Footer />
          <WhatsAppFloat />
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}
